import { ReactNode, useEffect, useState } from "react";
import { IRentersNegativation } from "@/types/renters-negativation.type";
import { initialState, NegativationDashboardContext } from "./NegativationDashboard.context";
import { getNegativationById, updateNegatiation } from "@/common/services/renter-negativation.api";

type Props = {
  children: ReactNode,
  negativationId: string
}

export function NegativationDashboardProvider(props: Props) {

  const [negativation, setNegativation] = useState<IRentersNegativation>(initialState.negativation)

  useEffect(() => {
    async function loadNegativation(negativationId: string) {
      const result = await getNegativationById(negativationId)

      if (result.ok) {
        setNegativation(result.data as IRentersNegativation)
      }
    }

    loadNegativation(props.negativationId)
  }, [props.negativationId])

  async function saveNegativation(dataToSave: IRentersNegativation) {
    try {
      const { ok, data, errors } = await updateNegatiation(negativation._id as string, dataToSave)

      if (ok && data) {
        setNegativation(data as IRentersNegativation)
        return { ok, data: data as IRentersNegativation, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: data as IRentersNegativation, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      console.log(err)

      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { negativation, saveNegativation }

  return (
    <NegativationDashboardContext.Provider value={theState}>
      {props.children}
    </NegativationDashboardContext.Provider>
  )
}